import React from "react";

/**
 * Tab row (§2.7). Controlled: parent owns `active` and renders the panel.
 * tabs: [{ key, label, count? }]
 */
function Tabs({ tabs, active, onChange }) {
  return (
    <div className="fk-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          className={`fk-tab${active === tab.key ? " fk-tab--active" : ""}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
          {tab.count !== undefined ? <span className="fk-tab__count">{tab.count}</span> : null}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
